import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const QuickViewContext = createContext(null);

export const QuickViewProvider = ({ children }) => {
    const [product, setProduct] = useState(null);

    const open = useCallback((p) => setProduct(p), []);
    const close = useCallback(() => setProduct(null), []);

    const value = useMemo(() => ({ product, open, close, isOpen: !!product }), [product, open, close]);

    return <QuickViewContext.Provider value={value}>{children}</QuickViewContext.Provider>;
};

export const useQuickView = () => {
    const ctx = useContext(QuickViewContext);
    if (!ctx) throw new Error("useQuickView must be used within QuickViewProvider");
    return ctx;
};
